import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';

export default function CheckboxColumn({ row, col, cell }) {
  const renderCheckbox = ({ row, col, cell }) => {
    // eslint-disable-next-line max-len
    const className = !cell?.value && !cell?.disabled ? 'custom-checkbox-color fill-checkbox' : 'custom-checkbox-color disabled-column';

    return (
      <label className="checkbox-column">
        {cell?.useBulkActions ? (
          <Checkbox
            type="checkbox"
            className={`${className} ${cell?.isMultilined ? 'multilined-checkbox' : ''}`}
            onChange={() => col.columnConfig.onClick(row, !cell.value, col)}
            checked={cell.value}
            disabled={cell.disabled}
          />
        ) : (
          <input
            type="checkbox"
            onChange={() => col.columnConfig.onClick(row, !cell.value, col)}
            checked={cell.value}
            disabled={cell.disabled}
          />
        )}

      </label>
    );
  };
  return cell.tooltipText ? (
    <Tooltip arrow title={cell.tooltipText} placement="bottom">
      {renderCheckbox({ row, col, cell })}
    </Tooltip>
  ) : (
    renderCheckbox({ row, col, cell })
  );
}

CheckboxColumn.defaultWidth = 40;

CheckboxColumn.propTypes = {
  row: PropTypes.object.isRequired, // row data
  col: PropTypes.shape({
    columnConfig: PropTypes.shape({
      onClick: PropTypes.func.isRequired, // (row:obj, value:bool) :=> {}
    }).isRequired,
  }).isRequired, // column config
  cell: PropTypes.shape({
    value: PropTypes.bool,
  }).isRequired,
  useBulkActions: PropTypes.bool,
};
